// takes the firebase object and then returns an array of the nested properties
// and moves the firebase key inside the objects

export default (firebaseObject) => Object.entries(firebaseObject).map(([key, value]) => {
    value.firebaseKey = key // adds id firebase location id to the object inside.
    return value
})